function extractAndInsertDimensions() {
	function onUrlChange() {
		let oldHref = location.href;

		const body = document.querySelector("body");
		const observer = new MutationObserver(() => {
			if (oldHref !== location.href) {
				oldHref = location.href;

				updateDescription();
			}
		});

		observer.observe(body, { childList: true, subtree: true });
	}
	onUrlChange();

	function formatMeasurementValue(value) {
		const numberValue = Number(value);
		if (!Number.isFinite(numberValue)) return '';

		return Number.isInteger(numberValue) ? String(numberValue) : String(numberValue);
	}

	function getDimensionLabels(dimensionKey) {
		return dimensionKey.labels || [dimensionKey.key];
	}

	function getDimensionNameFromText(text, dimensionKeys) {
		const normalizedText = text.toLowerCase();
		const matchedDimension = dimensionKeys.find((dimensionKey) => {
			return getDimensionLabels(dimensionKey).some((label) => normalizedText.includes(label.toLowerCase()));
		});

		return matchedDimension?.name || null;
	}

	function extractMmValue(text) {
		const mmMatch = text.match(/(\d+(?:\.\d+)?)\s*mm/i);
		return mmMatch ? parseFloat(mmMatch[1]) : null;
	}

	function extractInchesValue(text) {
		const inMatch = text.match(/\(?(\d+(?:\.\d+)?)\s*inches\)?/i);
		return inMatch ? parseFloat(inMatch[1]) : null;
	}

	function extractDimensionsFromSpans(spans, dimensionKeys, dimensions) {
		spans.forEach((span) => {
			const text = span.textContent.trim();
			const dimensionName = getDimensionNameFromText(text, dimensionKeys);
			const siblingText = span.nextElementSibling?.textContent.trim() || '';
			const parentText = span.parentElement?.textContent.trim() || '';

			if (dimensionName) {
				const parentDimensionName = parentText ? getDimensionNameFromText(parentText, dimensionKeys) : null;
				const parentValueText = parentDimensionName === dimensionName ? parentText : '';
				const mmValue = extractMmValue(text) ?? extractMmValue(siblingText) ?? extractMmValue(parentValueText);
				const inchesValue = extractInchesValue(text) ?? extractInchesValue(siblingText) ?? extractInchesValue(parentValueText);

				if (mmValue !== null) {
					dimensions[dimensionName].mm = mmValue;
				}

				if (inchesValue !== null) {
					dimensions[dimensionName].in = inchesValue;
				}

				return;
			}

			if (text.includes('inches')) {
				const inchesValue = extractInchesValue(text);
				const prevText = span.previousElementSibling?.textContent.trim() || '';
				const prevDimensionName = getDimensionNameFromText(prevText, dimensionKeys);

				if (inchesValue !== null && prevDimensionName) {
					dimensions[prevDimensionName].in = inchesValue;
				}
			}
		});
	}

	function updateRxHeadSizeRow(dimensions) {
		const sizeText = document.querySelector('[data-rx-head-size-text]');
		if (!sizeText) return;

		const sizeValue = sizeText.querySelector('[data-rx-head-size-value]');
		const getFallbackMmValue = (value) => {
			const numberValue = Number.parseFloat(value);
			return Number.isFinite(numberValue) ? numberValue : null;
		};
		const values = [
			dimensions?.lensWidth?.mm ?? getFallbackMmValue(sizeText.dataset.rxHeadLensWidthMm),
			dimensions?.noseBridge?.mm ?? getFallbackMmValue(sizeText.dataset.rxHeadBridgeMm),
			dimensions?.templeSize?.mm ?? getFallbackMmValue(sizeText.dataset.rxHeadTempleMm),
		];
		const hasAllValues = values.every((value) => value !== null && value !== undefined);

		if (!hasAllValues) {
			if (sizeValue) sizeValue.textContent = '';
			sizeText.hidden = true;
			return;
		}

		if (sizeValue) {
			const formattedSize = `${values.map(formatMeasurementValue).join('-')}mm`;
			const sizeLabel = sizeText.dataset.rxHeadSizeLabel?.trim();
			sizeValue.textContent = sizeLabel ? `${sizeLabel} (${formattedSize})` : formattedSize;
		}

		sizeText.hidden = false;
	}

	// Products with the frame size picker fill this row from frame-size-selector.js
	function updateSizePopupMeasurements(container) {
		if (document.querySelector('[data-frame-size-picker]')) return;

		const pattern =
			/(lens width|lens height|nose bridge|bridge width|hinge to hinge|temple size|temple length|frame width)\s*:?\s*(\d+(?:\.\d+)?)\s*mm(?:\s*\(?\s*(\d+(?:\.\d+)?)\s*inch(?:es)?\s*\)?)?/gi;
		const text = container?.textContent || '';
		const seen = new Set();
		const rows = [];
		let match;
		while ((match = pattern.exec(text))) {
			const key = match[1].toLowerCase();
			if (seen.has(key)) continue;
			seen.add(key);
			rows.push({ label: match[1], mm: match[2], inches: match[3] || '' });
		}

		const sizeText = document.querySelector('[data-rx-head-size-text]');
		const fitLabel = sizeText?.dataset.rxHeadSizeLabel?.trim() || '';

		document.querySelectorAll('[data-frame-size-measurements]').forEach((box) => {
			box.textContent = '';
			if (!rows.length) {
				box.hidden = true;
				return;
			}

			const title = document.createElement('p');
			title.className = 'frame-size-measurements__title';
			if (fitLabel) {
				const fit = document.createElement('span');
				fit.textContent = fitLabel;
				title.append('Your frame: ', fit);
			} else {
				title.textContent = 'Your frame';
			}
			box.appendChild(title);

			const list = document.createElement('dl');
			list.className = 'frame-size-measurements__list';
			rows.forEach((row) => {
				const item = document.createElement('div');
				item.className = 'frame-size-measurements__row';
				const term = document.createElement('dt');
				term.textContent = row.label;
				const value = document.createElement('dd');
				value.textContent = `${row.mm}mm`;
				if (row.inches) {
					const inches = document.createElement('span');
					inches.textContent = `${row.inches} in`;
					value.appendChild(inches);
				}
				item.appendChild(term);
				item.appendChild(value);
				list.appendChild(item);
			});
			box.appendChild(list);
			box.hidden = false;
		});
	}

	function updateDescription() {
		const productDataElement = document.getElementById('product-data-with-metafields');
		if (!productDataElement) {
			console.warn('[Product Dimensions] Product data element not found');
			return;
		}

		const productData = JSON.parse(productDataElement.textContent);
		const { product, productVariants } = productData;
		let variantId = readVariantId();

		if(variantId) {
			const currentVariant = productVariants.find(variant => variant.id === variantId);
			const metafields = currentVariant?.metafields?.custom_field;

			if(metafields) {
				const parentTab = [
					document.querySelector('.product__accordion.description'),
					document.querySelector('.wmp-dimensions .hidden')
				];

				parentTab.forEach(el => {
					if (!el) return;
					const spans = el.querySelectorAll('.accordion__content div');
					spans.forEach(span => {
						const items = span.querySelectorAll('span');
						if(items.length === 2) {
							metafields.forEach(metafield => {
								const line_1 = metafield.split(' || ')[0];
								const line_2 = metafield.split(' || ')[1];
								const key = line_1.split(': ')[0];


								if(items[0].textContent.includes(key)) {
									items[0].textContent = `${line_1}`;
									items[1].textContent = `${line_2}`;
								}
							})
						}
					})
				})
			} else {
				const description = product.description;
				const tabDescription = document.querySelector('.product__accordion.description .accordion__content');
				const hiddenEl = document.querySelector('.wmp-dimensions .hidden');
				if (tabDescription) tabDescription.innerHTML = description || '';
				if (hiddenEl) hiddenEl.innerHTML = description || '';
			}
		}

		let hiddenContainer = document.querySelector('.wmp-dimensions .hidden');
		if (!hiddenContainer) {
			hiddenContainer = document.createElement('div');

			const descriptionContainer = document.querySelector('.product__accordion.description .accordion__content');
			hiddenContainer.innerHTML = descriptionContainer?.innerHTML || product.description || '';
		}

		const dimensionsGlasses = {
			lensWidth: { mm: null, in: null },
			lensHeight: { mm: null, in: null },
			noseBridge: { mm: null, in: null },
			hingeToHinge: { mm: null, in: null },
			templeSize: { mm: null, in: null },
			frameWidth: { mm: null, in: null },
		};

		const dimensionsJewelry = {
			length: { mm: null, in: null },
			width: { mm: null, in: null },
			height: { mm: null, in: null },
		};

		const dimensionKeysGlasses = [
			{ key: 'Lens Width', labels: ['Lens Width'], name: 'lensWidth', svgId: 'lens' },
			{ key: 'Lens Height', labels: ['Lens Height'], name: 'lensHeight', svgId: 'height' },
			{ key: 'Nose Bridge', labels: ['Nose Bridge', 'Bridge Width'], name: 'noseBridge', svgId: 'bridge-text' },
			{ key: 'Hinge to Hinge', labels: ['Hinge to Hinge'], name: 'hingeToHinge', svgId: 'width' },
			{ key: 'Temple Size', labels: ['Temple Size', 'Temple Length'], name: 'templeSize', svgId: 'temple' },
			{ key: 'Frame Width', labels: ['Frame Width'], name: 'frameWidth', svgId: 'frame' },
		];

		const dimensionKeysJewelry = [
			{ key: 'Length', labels: ['Length'], name: 'length', svgId: 'length' },
			{ key: 'Width', labels: ['Width'], name: 'width', svgId: 'width' },
			{ key: 'Height', labels: ['Height'], name: 'height', svgId: 'height' },
		];

		const spans = hiddenContainer.querySelectorAll('span');
		extractDimensionsFromSpans(spans, dimensionKeysGlasses, dimensionsGlasses);
		extractDimensionsFromSpans(spans, dimensionKeysJewelry, dimensionsJewelry);
		updateRxHeadSizeRow(dimensionsGlasses);
		updateSizePopupMeasurements(hiddenContainer);

		const svgContainer = document.querySelector('.product-dimensions-one-img svg');
		if (!svgContainer) {
			if (!document.querySelector('.custom_size_chart-image')) {
				console.error('SVG-container .product-dimensions-one-img svg not found');
			}
			return;
		}

		const isJewelrySvg = svgContainer.querySelector('text#length');
		const dimensionKeys = isJewelrySvg ? dimensionKeysJewelry : dimensionKeysGlasses;
		const dimensions = isJewelrySvg ? dimensionsJewelry : dimensionsGlasses;

		dimensionKeys.forEach(({ name, svgId }) => {
			const textElement = svgContainer.querySelector(`text#${svgId}`);
			if (textElement) {
				const mmTspan = textElement.querySelector('tspan:first-child');
				const inTspan = textElement.querySelector('tspan:last-child');
				if (mmTspan && dimensions[name].mm !== null) {
					mmTspan.textContent = `${dimensions[name].mm}mm`;
				}
				if (inTspan && dimensions[name].in !== null) {
					inTspan.textContent = `(${dimensions[name].in} ${name === 'hingeToHinge' ? 'inches' : 'inches'})`;
				}
			} else {
				console.warn(`Element text#${svgId} wasn't found at SVG`);
			}
		});

		const hasDimensions = Object.values(dimensions).some((dim) => dim.mm !== null);
		if (hasDimensions) {
			document.querySelector('.wmp-dimensions').classList.add('wmp-dimensions--shown');
		}
	}

	window.updateDescriptionGlobal = updateDescription;
	window.updateDescriptionGlobal();

		function readVariantId() {
		const url = new URL(window.location.href);
		const variant = url.searchParams.get('variant');

		if(variant) {
			return +variant;
		}
		else return null;
	}
	readVariantId();
}

document.addEventListener('DOMContentLoaded', () => {
  extractAndInsertDimensions();
});
